document.addEventListener("DOMContentLoaded", function () {
  
  // --- Tabs switching ---
  document.querySelectorAll(".pro-rev-tab").forEach(function (tab) {
    tab.addEventListener("click", function () {
      const tabID = this.dataset.tab;
      
      document.querySelectorAll(".pro-rev-tab").forEach(el => el.classList.remove("pro-rev-active"));
      this.classList.add("pro-rev-active");
      
      document.querySelectorAll(".pro-rev-tab-content").forEach(el => el.classList.remove("pro-rev-active"));
      document.getElementById(tabID)?.classList.add("pro-rev-active");
    });
  });
  const jdgmWidget = document.querySelector('.jdgm-all-reviews-widget');
  if (jdgmWidget && document.querySelector('.pro-rev-all-store')) {
    document.querySelector('.pro-rev-all-store').innerHTML = jdgmWidget.outerHTML;
  }
  
  
  
  // fancybox start

    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('fancybox__backdrop')) {
        e.stopPropagation();
        e.preventDefault();
        if (window.Fancybox?.close) Fancybox.close();
      }
    }, true); // capture to run before Fancybox’s own handler


  // fancybox ends

});



